import { Injectable } from '@angular/core';
import { Core2Config } from '../../shared/core2Config';
import { HttpClient } from '@angular/common/http';
import { WarrantyCertificateContainerModel } from '../../../../../../models/aggregates/erp/warranty';
import { ApiResponseModel, ApiVisa, BasicApiResponseModel } from '../../shared';
import { Observable } from 'rxjs';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';

@Injectable({
  providedIn: 'root'
})
export class WarrantyCertificateService extends BaseApiPublicLoginTemplateService<WarrantyCertificateContainerModel, WarrantyCertificateContainerModel, WarrantyCertificateContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.WARRANTY_PREFIX + 'warranty-certificates' + Core2Config.BACKOFFICE_EP_SUFFIX;

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.WARRANTY_PREFIX + 'warranty-certificates/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.WARRANTY_PREFIX + 'warranty-certificates/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.WARRANTY_PREFIX + 'warranty-certificates/' + Core2Config.LOGIN_ENTITY_EP_SUFFIX;
    this.httpClient = http;
  }

  postLoginEntity(dtoObject: WarrantyCertificateContainerModel, visa: ApiVisa): Observable<ApiResponseModel<WarrantyCertificateContainerModel>> {
    let url = this.apiUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path_login_url;
    }
    return this.httpClient.post<ApiResponseModel<WarrantyCertificateContainerModel>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  /**Get All (Login Entity Ep) */
  getAllLoginEntity(visa: ApiVisa): Observable<ApiResponseModel<WarrantyCertificateContainerModel>> {
    let url = this.apiUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path_login_url;
    }
    return this.httpClient.get<ApiResponseModel<WarrantyCertificateContainerModel>>(
      url,
      this.getHttpHeader(visa)
    );
  }

  putLoginEntity(dtoObject: WarrantyCertificateContainerModel, visa: ApiVisa): Observable<BasicApiResponseModel<WarrantyCertificateContainerModel>> {
    let url = this.apiUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path_login_url;
    }
    return this.httpClient.put<BasicApiResponseModel<WarrantyCertificateContainerModel>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  /** Delete branch */
  deleteLoginEntity(guid: string, visa: ApiVisa): Observable<ApiResponseModel<WarrantyCertificateContainerModel>> {
    let url = this.apiUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path_login_url;
    }
    return this.httpClient.delete<ApiResponseModel<WarrantyCertificateContainerModel>>(
      url + '/' + guid,
      this.getHttpHeader(visa)
    );
  }
}
